import { Route } from '@angular/router';
import { QueryFormComponent } from './components/query-form/query-form.component';
import { QueryListComponent } from './components/query-list/query-list.component';
import { keycloakGuard } from '@peca/keycloak';

export const queryRoutes: Route[] = [
  {
    path: 'create-query',
    component: QueryFormComponent,
    canActivate: [keycloakGuard(['dialect-query-criar'])],
  },
  {
    path: ':queryId',
    component: QueryFormComponent,
    canActivate: [keycloakGuard(['dialect-query-listar'])],
  },
  {
    path: '',
    component: QueryListComponent,
    canActivate: [keycloakGuard(['dialect-query-listar'])],
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '',
  },
];
